import React, { useContext } from 'react';

import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import ParentPostLabel from 'screens/common/parentPostLabel';
import { NewDueDateField } from 'screens/common/sidepanel/DetailSection/DueDateField';
import { getDateTooltip } from 'screens/common/sidepanel/DetailSection/GoalDetailSection';
import { selectGoalFromGlobalGoals } from 'selectors/globalGoalSelector';
import styled from 'styled-components';

import { MESH_LIST_TABS } from 'constants/ProjectConstants';

import { isRecurrent } from 'services/helpers/task';

import AddToAgendaComponent from '../AddToAgendaComponent';
import DetailIconComponent from '../DetailIconComponent';
import MarkComplete from '../MarkComplete';
import MeshListContext from '../MeshListContext';
import TaskOrGoalName from '../TaskOrGoalName';
import { ListItemCSS, ListIemUpdatingCSS } from '../styles';
import TaskStats from './TaskStats';
import TaskToIds from './TaskToIds';

const StyledMarkComplete = styled(MarkComplete)`
  margin-left: -5px;
`;

export default function TaskListItem({ task: localTask, onClickHandler, style, showAddToAgenda = false }) {
  const { dispatch, employee } = useContext(MeshListContext);

  const task = useSelector(selectGoalFromGlobalGoals(localTask?.id)) ?? localTask;

  const coloredDueDate = task.dueTime || {};

  return (
    <Container onClick={onClickHandler} style={style}>
      <ParentPostLabel parentPosts={task.parentPosts} />
      <FirstRow>
        {/* <StyledMarkComplete
          dispatch={dispatch}
          taskId={task.uuid}
          taskKey={task.key}
          isComplete={isComplete(task.completionTS)}
        /> */}
        <Box ml="14px" mr="auto">
          <TaskOrGoalName text={task.title || ''} macros={task.macros} isCompleted={task.status === 'COMPLETED'} />
        </Box>

        {showAddToAgenda ? <StyledAddToAgendaComponent type={MESH_LIST_TABS.task.taskType} task={task} /> : null}

        <StyledDetailIconComponent
          tooltipText="Open Details Panel"
          taskId={task.uuid}
          taskKey={task.key}
          dispatch={dispatch}
          employee={employee}
        />
      </FirstRow>
      <SecondRow>
        <div>
          <NewDueDateField
            dueDate={coloredDueDate.timeStamp ? new Date(coloredDueDate.timeStamp) : null}
            color={coloredDueDate.color}
            hoverText={getDateTooltip({
              date: coloredDueDate.timeStamp,
              status: task.detailedStatus,
              reason: coloredDueDate.reason,
            })}
            isCrossed={coloredDueDate.isCrossed}
            taskId={task.uuid}
            taskKey={task.key}
            dispatch={dispatch}
            disableOnClick
          />
        </div>
        <TaskStats
          isEditing={task.isEditing}
          isRecurrent={isRecurrent(task.taskType)}
          discussionCommentsCount={task.discussionCommentsCount}
          totalSubtasks={task?.subTaskStats?.total || 0}
          completedSubTasks={task?.subTaskStats?.completed || 0}
        />
        <ToIdsContainer>
          <TaskToIds
            taskId={task.uuid}
            taskKey={task.key}
            dispatch={dispatch}
            employees={task.toIds}
            isEditing={task.isEditing}
            maxNodes={3}
            iconSize="fixed28px"
            renderEmptyView={
              (props) => null
              // <AddPeerIcon
              //   {...props}
              //   color="white"
              //   circular
              //   size="fixed24px"
              //   style={{ marginLeft: task?.toIds?.length ? '-6px' : '0px' }}
              // />
            }
            disableOnClick
          />
        </ToIdsContainer>
      </SecondRow>
    </Container>
  );
}

const StyledDetailIconComponent = styled(DetailIconComponent)``;
const StyledAddToAgendaComponent = styled(AddToAgendaComponent)``;

const Container = styled.div`
  position: relative;
  ${ListItemCSS};
  ${ListIemUpdatingCSS};
  cursor: pointer;
  &:hover {
    ${StyledDetailIconComponent} {
      visibility: visible;
      border-radius: 50%;
      background-color: white;
    }
    ${StyledAddToAgendaComponent} {
      visibility: visible;
    }
    z-index: 100;
    box-shadow:
      0 1px 2px 0 ${(props) => props.theme.palette.shadows.card},
      0 2px 6px 2px ${(props) => props.theme.palette.shadows.card};
    background-color: ${(props) => props.theme.palette.background.blue.light.v2};
  }
`;

const FirstRow = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
  padding-bottom: 1rem;
`;

const SecondRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  align-items: center;
  grid-gap: 1rem;
`;

const ToIdsContainer = styled.div`
  text-align: right;
`;
